import debounce from 'lodash.debounce'

const root = document.documentElement
const header = document.querySelector('#main-header')

const headerProps = {
    height: 0,
}

const getHeaderHeight = () => {
    if (!header) return headerProps

    headerProps.height = header.offsetHeight
    return headerProps
}

const setHeaderHeight = () => {
    const { height } = getHeaderHeight()
    root.style.setProperty('--header-height', `${height}px`)
}

//declare and update a variable '--header-height'
const responsiveHeaderHeight = () => {
    setHeaderHeight()

    window.addEventListener('resize', debounce(setHeaderHeight, 100))
}

export { headerProps, getHeaderHeight, responsiveHeaderHeight }
